/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ExternalUserLinkAccount' store object.
 * @namespace ExternalUserLinkAccountSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAExternalUserLinkAccount';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserLinkAccountSelectors
   */
  static postSdExternaluserLinkAccount = state =>
    state[selectors.moduleIdentifier].postSdExternaluserLinkAccount.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserLinkAccountSelectors
   */
  static isFetchingPostSdExternaluserLinkAccount = state =>
    state[selectors.moduleIdentifier].isFetchingPostSdExternaluserLinkAccount.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserLinkAccountSelectors
   */
  static postSdExternaluserLinkAccountError = state =>
    state[selectors.moduleIdentifier].postSdExternaluserLinkAccountError.payload;
}
